import { TALK_TO_US } from '@spa/shared/components/Header/Desktop/tabs/tabsLinksData';

export const GUEST_DROPDOWN_ITEMS = [
  {
    link: `${process.env.SELF_SERVICE_URL}`,
    key: 'List your property',
    target: '_blank'
  },
  {
    href: (language = 'en') => `${process.env.APP_URL}${language}/how-it-works`,
    key: 'How it works',
    target: '_blank'
  },
  {
    href: (language = 'en') => TALK_TO_US[language.toUpperCase()],
    key: 'Contact us',
    target: '_blank'
  },
  {
    link: `${process.env.HELP_URL}`,
    key: 'Help centre',
    target: '_blank'
  },
  {
    key: 'Become an Ambassador',
    link: `${process.env.AMBASSADOR_URL}`,
    separator: true,
    target: '_blank'
  },
  {
    key: 'Sign up',
    link: '/signup'
  },
  {
    key: 'Log in',
    link: '/login'
  }
];
